import Spinner from 'components/Spinner';
import { P } from '../Text';
import BaseModal from './BaseModal';

interface Props {
  closeModal: () => void;
  modalOpen: boolean;
  // What the wait is for, already translated (WHIT-494).
  message: string;
}

const LoaderModal: React.FC<Props> = ({ closeModal, modalOpen, message }) => {
  return (
    <BaseModal modalOpen={modalOpen} closeModal={closeModal} cancelDisabled>
      {/* Centred with a spinner, like BookingProgressModal (WHIT-478). */}
      <div className="flex flex-col items-center px-6 py-4">
        <Spinner />
        <P className="mt-4" centered>
          {message}
        </P>
      </div>
    </BaseModal>
  );
};

export default LoaderModal;
